/** Texto de hover compartido por cada punto de entrada a Qubi (header, disparador flotante, sidebar). */
export const NOZ_TOOLTIP_TITLE = 'Qubi, tu compañero de IA';
